<div>
    <app-bar-chart [barData]="pronunciationScores" [stepType]="step.positionStep.questionCollection.questionCollectionCategory"></app-bar-chart>
</div>